import Client from './client';

export default class RestrictionOrganizations extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getRestrictionAndStatusByOrganization(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/status`, options);
  }

  postRestrictionAndStatusByOrganization(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/status`, {
      ...options,
       method: 'POST',
    });
  }

  putRestrictionAndStatusByOrganization(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/status`, {
      ...options,
       method: 'PUT',
    });
  }

  getSearchAndRestrictionAndOrganizations(options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/search/restriction/organizations`, options);
  }

}
